<app-dialog-header [title]="'Abrir novo chamado'"></app-dialog-header>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="new-support">
      <div class="new-support__field">
        <label class="form-label" for="title">Título</label>
        <input
          id="title"
          type="text"
          class="form-control"
          formControlName="title"
          placeholder="Resuma o seu problema"
          [class.is-invalid]="controls.title.invalid && controls.title.touched" />
        @if (controls.title.touched && controls.title.hasError("required")) {
          <div class="text-danger">Esse campo é obrigatório.</div>
        }
        @if (controls.title.touched && controls.title.hasError("maxlength")) {
          <div class="text-danger">O título deve ter no máximo 120 caracteres.</div>
        }
      </div>

      <div class="new-support__field">
        <label class="form-label" for="description">Descrição</label>
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
          rows="5"
          placeholder="Descreva o que aconteceu com o máximo de detalhes"
          [class.is-invalid]="controls.description.invalid && controls.description.touched"></textarea>
        @if (controls.description.touched && controls.description.hasError("required")) {
          <div class="text-danger">Esse campo é obrigatório.</div>
        }
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" [disabled]="loading" (btnClick)="dialogRef.close()">Cancelar</app-button>
  <app-button styleType="primary" [disabled]="loading" (btnClick)="confirm()">Abrir chamado</app-button>
</mat-dialog-actions>

@if (loading) {
  <app-loading />
}
